<button
  mat-icon-button
  [matMenuTriggerFor]="beforeMenu"
  class="settings-button"
  [attr.data-testid]="testIds.tableSettingsButton">
  <mat-icon svgIcon="settings-icon"></mat-icon>
</button>

<mat-menu
  #beforeMenu="matMenu"
  xPosition="after"
  class="custom-menu-position"
  [attr.data-testid]="testIds.columnSettingsMenu">
  @for (column of allColumns(); track column.key) {
    <mat-checkbox
      class="tim-checkbox"
      [checked]="isColumnVisible(column)"
      (change)="triggerColumnsToShow($event, column)"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      [disabled]="displayedColumns().length <= 1 && isColumnVisible(column)"
      [attr.data-testid]="'column_toggle_' + column.key">
      {{ column.label }}
    </mat-checkbox>
  }
</mat-menu>
